import React from 'react'
import { Result, Button } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { getWebPortalUrl } from '../config/runtimeEnv'

const NotConnected: React.FC = () => {
  const handleConnect = () => {
    window.location.href = `${getWebPortalUrl()}/settings/integrations`
  }

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      padding: '24px',
    }}>
      <Result
        icon={<MailOutlined style={{ color: '#ea4335' }} />}
        title="Gmail Not Connected"
        subTitle="Please connect your Gmail business account to access the Gmail portal."
        extra={[
          <Button type="primary" key="connect" onClick={handleConnect}>
            Go to Integrations Settings
          </Button>,
        ]}
      />
    </div>
  )
}

export default NotConnected

